import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DropdownField from '../../recordDetail/fields/DropdownField';
import FilterComponent from './FilterComponent';

import '../Filter.css';

class FilterWithSearchMulti extends FilterComponent {
  static get propTypes() {
    return {
      filterKey: PropTypes.string,
      setDisplayFilter: PropTypes.func,
      filterValue: PropTypes.any,
      onFilter: PropTypes.func,
      mapFn: PropTypes.func,
      possibleValues: PropTypes.array,
      renderer: PropTypes.func,
      recentlyUsed: PropTypes.array,
      recentlyUsedKey: PropTypes.string
    };
  }

  constructor(props) {
    super(props);

    const { filterValues, propertyName, recentlyUsed } = props;

    const values = this.getInitialisedValues(recentlyUsed, propertyName, filterValues);

    this.state = {
      values,
      value: undefined
    };
  }

  getInitialisedValues(recentlyUsed, propertyName, filterValues) {
    const values = filterValues.map((filterValue) => {
      const recentValue = recentlyUsed
        && recentlyUsed.find(r => r[propertyName] === filterValue);

      // Use the full object if already stored in recentlyUsed
      if (recentValue) {
        return recentValue;
      }
      // Otherwise just use the key
      const value = {};
      value[propertyName] = filterValue || undefined;
      // Indicate that this is just a key so it is not later stored
      // to recentlyUsed reducer
      value.keyOnly = true;
      return value;
    });
    return values;
  }

  onFilter() {
    const { onFilter, filterKey, propertyName, recentlyUsedKey } = this.props;
    const { values } = this.state;
    const filterValues = values
      ? values.map(val => val[propertyName]).join(',')
      : undefined;
    const recentlyUsedValues = recentlyUsedKey ? values : undefined;

    onFilter(filterKey, filterValues, recentlyUsedKey, recentlyUsedValues);
  }

  onAddSelection(selected) {
    const { values } = this.state;
    let newValues;
    if (selected) {
      newValues = values.concat(selected);
    }
    // Add new value and reset the selection
    this.setState({ values: newValues, value: undefined });
  }

  onRemoveAllSelections() {
    this.setState({ values: [] });
  }

  onRemoveSelection(selected) {
    const { values } = this.state;
    const index = values.indexOf(selected);

    const trimmedValues = values.concat();
    if (index !== -1) {
      trimmedValues.splice(index, 1);
    }

    this.setState({ values: trimmedValues });
  }

  renderSelectedList() {
    const { renderer, possibleValues, mapFn, propertyName } = this.props;
    const { values } = this.state;
    const options = possibleValues.map(mapFn);

    const selections = (values.map((val, index) => {
      const displayOption = options.find(o => o.value === val[propertyName]);

      return (<div className="FilterValueItem" key={this.key(index)}>
        <button
          className="remove-filter-selection"
          onClick={() => this.onRemoveSelection(val)}
        />
        <span className="filter-selected-value">
          { renderer
            ? renderer(val)
            : `${displayOption ? displayOption.label : ''}\u00a0`
          }
        </span>
      </div>);
    }));

    if (selections.length < 2) return selections;

    const clear = (<div className="FilterValueItem clear">
      <button
        className="remove-filter-selection clear"
        onClick={() => this.onRemoveAllSelections()}
        title="Click to clear selections"
      />
    </div>);

    return [clear, ...selections];
  }

  key(index) {
    return `val-${index}`;
  }

  renderFilterBody() {
    const { filterKey, mapFn, possibleValues, label, renderer, propertyName } = this.props;
    const { value, values } = this.state;
    // Filter out the currently selected items
    const filteredValues = possibleValues.filter(possVal =>
      !values.find(val => val[propertyName] === possVal[propertyName])
    );

    return (
      <div className="Filter-body">
        <DropdownField
          name={`filter-${filterKey}`}
          className={classnames('Filter-search', `select-filter-${filterKey}`)}
          placeholder={label}
          mapFn={mapFn}
          editing
          label={label}
          value={value}
          possibleValues={filteredValues}
          onChange={selected => this.onAddSelection(selected)}
          filterField
          renderer={renderer}
        />
        {this.renderSelectedList()}
      </div>
    );
  }
}

export default FilterWithSearchMulti;



// WEBPACK FOOTER //
// ./src/filter/filterTypes/FilterWithSearchMulti.js